import { render } from "./ExtraContent.vue?vue&type=template&id=f196a098&scoped=true"
import script from "./ExtraContent.vue?vue&type=script&lang=ts"
export * from "./ExtraContent.vue?vue&type=script&lang=ts"

import "./ExtraContent.vue?vue&type=style&index=0&id=f196a098&scoped=true&lang=css"
import "../../components/Video/VideoStyling.css?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-f196a098"

export default script